import Vue from 'vue'
import Vuex from 'vuex'

// Se almacenam los datos a editar (telefonos, mails, etc) de manera temporal

Vue.use(Vuex)
export default ({
    namespaced: true,

    state: {
        itemSelected: [],
        indiceSelected: ''
    },

    getters: {
        itemSelected(state) {
            return state.itemSelected
        },
        indiceSelected(state) {
            return state.indiceSelected
        },
    },
    mutations: {
        setItemSelected(state, payload) {
            if (payload.indice !== undefined) {
                state.itemSelected = payload.data
                state.indiceSelected = payload.indice
            } else {
                state.itemSelected = payload
                state.indiceSelected = ''
            }
        },
    },
    actions: {
        cargarItem({ commit, dispatch }, payload) {
            commit('setItemSelected', payload)
        },

        vaciarItem({ commit, dispatch }) {
            commit('setItemSelected', '')
        },
    },


})